export default __webpack_public_path__ + "static/media/Edit.e2e0ad48.svg";